export default __webpack_public_path__ + "static/media/expenses.e24f8b03.svg";